import { render, staticRenderFns } from "./PutOnStockManage.vue?vue&type=template&id=37a698ee&scoped=true&"
import script from "./PutOnStockManage.vue?vue&type=script&lang=js&"
export * from "./PutOnStockManage.vue?vue&type=script&lang=js&"
import style0 from "./PutOnStockManage.vue?vue&type=style&index=0&id=37a698ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a698ee",
  null
  
)

export default component.exports